import { useAuth } from '../contexts/AuthContext'
import { assistantScope, canUseAssistant, type AssistantScope } from '../lib/assistantAccess'

/** Whether to offer the AI here, and the scope its requests carry (see lib/assistantAccess). */
export function useAssistantAccess(): { available: boolean; scope: AssistantScope } {
  const { hasPermission, isPlatformAdmin, activePersona, modules } = useAuth()
  return {
    available: canUseAssistant({ hasPermission, isPlatformAdmin, activePersona, modules }),
    scope: assistantScope(activePersona),
  }
}
